// /skill, /credits, ...: one of the control plane's agent documents as a
// page (content/agentDocs.ts). The server renders the document into the
// page as it serves it (server/src/docs.js), so a crawler gets the whole
// thing with no script; this only keeps that markup, and fetches the
// document when the page is reached without a page load.

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../api';

declare global {
  // eslint-disable-next-line no-var
  var __AGENT_DOC__: { name: string; html: string } | undefined;
}

export default function DocPage() {
  const name = useLocation().pathname.replace(/^\/|\/$/g, '');
  const [doc, setDoc] = useState(() => {
    const served = typeof window !== 'undefined' ? window.__AGENT_DOC__ : undefined;
    return served?.name === name ? served : { name, html: '' };
  });

  const loaded = doc.name === name && doc.html !== '';

  useEffect(() => {
    if (loaded) return;
    api.get<{ html: string }>(`/agent-docs/${name}.json`).then((result) => setDoc({ name, html: result.html }), () => {});
  }, [name, loaded]);

  return (
    <main className="section">
      <article className="legal-body agent-doc" dangerouslySetInnerHTML={{ __html: doc.name === name ? doc.html : '' }} />
    </main>
  );
}
